import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../../WifiConnect.module.scss';

export type CorpTeamDeviceDescription = {
  showDescription: boolean;
  network_name: string;
};

export const CorpTeamDeviceDescription: React.FC<CorpTeamDeviceDescription> = ({
  showDescription,
  network_name,
}) => {
  return (
    <div>
      {showDescription ? (
        <div className="ray-grid__cell--span-full" style={{ marginBottom: 15 }}>
          <span>
            <b>
              <FormattedMessage
                id={'tabs.device.corpTeamInstructions.title'}
                defaultMessage="For corporate IoT or team devices ONLY:"
              />
            </b>
          </span>
          <br />
          <span>
            <FormattedMessage
              id="tabs.device.corpTeamInstructions.tabs.0"
              defaultMessage="Once the device is successfully connected to { network } WiFi, transfer the device MAC address to be managed by corp."
              values={{ network: network_name }}
            />
          </span>

          <ul className={styles.corpIoTInstructionsList}>
            <li>
              <span>
                <FormattedMessage
                  id="tabs.device.corpTeamInstructions.subTabs.0"
                  defaultMessage='Go to "Your registered devices" list'
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="tabs.device.corpTeamInstructions.subTabs.1"
                  defaultMessage="Click the 3 dots next to the corporate IoT or team device"
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="tabs.device.corpTeamInstructions.subTabs.2"
                  defaultMessage='Click "Manage by corp"'
                />
              </span>
            </li>
          </ul>
          <span>
            <FormattedMessage
              id="tabs.device.corpTeamInstructions.conclusion"
              defaultMessage="This will move the device MAC address out of your registered device list and have it be managed by corporate."
            />
          </span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
